import timeHelper from '../utils/timeHelper'

export default {
  data: () => ({
    selected: {
      week: 1,
      year: timeHelper.getCurrentYear()
    }
  }),
  created () {
    this.updateSelected()
    this.subs = this.$emitter.listen('routes.route-schedule-block-update', () => this.fetchData())
  },
  destroyed () {
    this.subs.unsubscribe()
  },
  computed: {
    hasRoutes () {
      return this.routes && this.routes.data && this.routes.data.length > 0
    },
    routes () {
      return this.$store.getters.readUrlEndpoint(this.getRoutesEndpoint())
    },
    cars () {
      return this.$store.getters.readUrlEndpoint(this.getCarsEndpoint())
    },
    shedules () {
      let indexed = {}
      let items = this.$store.getters.readUrlEndpoint(this.getScheduleEndpoint())
      if (items && items.data) {
        items.data.forEach(v => {
          let key = `route_${v.route_id}_${v.year}_${v.month}_${v.day}`
          indexed[key] = v
          if (v.car) {
            let keyByCar = `car_${v.car.id}_${v.year}_${v.month}_${v.day}`
            if (!indexed.hasOwnProperty(keyByCar)) {
              indexed[keyByCar] = []
            }
            indexed[keyByCar].push(v)
          }
        })
      }
      return indexed
    },
    weekRange () {
      let range = []
      for (let i = 1; i <= 7; i++) {
        range.push(i)
      }
      return range
    },
    selectedMonth () {
      let w = this.selected.week
      let y = this.selected.year
      return timeHelper.getMonthByWeek(w, y)
    },
    maxWeekInYear () {
      return 52
    }
  },
  methods: {
    fetchData () {
      let {asyncData} = this.$options
      this.$bar.start()
      asyncData({
        store: this.$store,
        methods: this
      }).then(() => {
        this.$bar.finish()
      }).catch(() => {
        this.$bar.finish()
      })
    },
    getOffsetDayByWeek: function (offset = 0) {
      return timeHelper.getOffsetDayByWeek(
        this.selected.week,
        offset,
        this.selected.year
      )
    },
    updateSelected () {
      this.selected.week = timeHelper.getCurrentWeek()
      this.selected.year = timeHelper.getCurrentYear()
    },
    nextWeek () {
      this.selected.week = this.selected.week + 1
      if (this.selected.week > this.maxWeekInYear) {
        this.selected.week = 1
        this.selected.year = this.selected.year + 1
      }
    },
    prevWeek () {
      this.selected.week = this.selected.week - 1
      if (this.selected.week < 1) {
        this.selected.year = this.selected.year - 1
        this.selected.week = this.maxWeekInYear
      }
    }
  },
  asyncData ({store, route, fromRoute, methods}) {
    let promises = []

    promises.push(store.dispatch('updateUrlEndpoint', {
      endpoint: methods.getRoutesEndpoint()
    }))

    promises.push(store.dispatch('updateUrlEndpoint', {
      endpoint: methods.getCarsEndpoint()
    }))

    promises.push(store.dispatch('updateUrlEndpoint', {
      endpoint: methods.getScheduleEndpoint()
    }))

    if (promises.length === 0) {
      return Promise.resolve(1)
    }

    return Promise.all(promises)
  }
}
